<template>
  
  <div class="chartStatus">
    <div class="chartItemTitulo">STATUS</div>
      <div class="chartItemIcone" id="iconeStatuschart">
        <i class="fas fa-thumbs-up"></i>
      </div>
      <div class="chartItemValor" id="valorStatuschart">SEM FALHAS</div>
  </div>

</template>

<script>

export default {
    name: 'ChartStatus'
}
</script>

<style>
.chartStatus {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
#iconeStatuschart {
  color: green;
  font-size: 8em;
  padding-top: 40px;
}
#valorStatuschart {
  font-size: 2em;
  padding-top: 124px;
  margin: 12.5px;
}
</style>